import styled from 'styled-components'
import Background from '../../assets/image.jpg'

export const Container = styled.header
`
    margin-top: -70px;
    height: 80vh;
    overflow: hidden;
    background: url(${Background});
    background-position: center;
    background-size: cover;
    img {
        z-index: -1;
        margin-top: -300px;
        min-width: 100%;
        filter: blur(1px);
    }
    @media (min-width: 1200px) {
        height: 70vh;
    }
    @media (min-width: 1400px) {
        height: 60vh;
    }
`

export const Title = styled.div<{scrollPosition: number;}>`
    background: hsla(0, 0%, 9%, 0.7);
    top: 0;
    left: 0;
    padding: 40px;
    color: #fff;
    height: 80vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content:center;
    transition: all ease 0.3s;
    .title{
        font-family: 'Poppins', 'Lucida Sans', sans-serif;
        font-size: 4rem;
    }

    .subtitle{
        font-family: 'Poppins', 'Lucida Sans', sans-serif;
        font-size: 2rem;
    }

    @media (min-width: 1200px) {
        height: 70vh;

        .title{
            font-family: 'Poppins', 'Lucida Sans', sans-serif;
            font-size: 5rem;
        }
    
        .subtitle{
            font-family: 'Poppins', 'Lucida Sans', sans-serif;
            font-size: 2.5rem;
        }
    }
    @media (min-width: 1400px) {
        height: 60vh;

        .title{
            font-family: 'Poppins', 'Lucida Sans', sans-serif;
            font-size: 6rem;
        }
    
        .subtitle{
            font-family: 'Poppins', 'Lucida Sans', sans-serif;
            font-size: 3rem;
        }
    }    
`